export const dashboardConstants = {
  LIST_ANALYTICS_REQUEST: 'LIST_ANALYTICS_REQUEST',
  LIST_ANALYTICS_SUCCESS: 'LIST_ANALYTICS_SUCCESS',
  LIST_ANALYTICS_FAILURE: 'LIST_ANALYTICS_FAILURE'
}